import OrgaoEmissorList from './list';

export default function OrgaoEmissorPage() {
  return <OrgaoEmissorList />;
}
